import React, { useContext, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AUTH_PREFIX_PATH, UNAUTHENTICATED_ENTRY, AUTH_TOKEN } from "configs/AppConfig";
import apiRequest from "services/ApiProvider";
import { verifyToken } from "services/AuthService";
import { AuthContext } from "context/AuthContext";

const ProtectedRoute = () => {
  const token = localStorage.getItem(AUTH_TOKEN);
  const userAuth = useContext(AuthContext);
  const verifyTokenAuth = async () => {
    const data = {};
    try {
      const response = await verifyToken(data);
      if (response.success === true && response.userDetails !== "NA") {
        const userDetails = response.userDetails;
        localStorage.removeItem("userDetails", userDetails);
        localStorage.setItem("userDetails", JSON.stringify(userDetails));
        userAuth.setUserDetails(userDetails);
        return false;
      } else {
        const msg = response.msg;
        apiRequest.consoleProvider("message false", msg);
        localStorage.removeItem(AUTH_TOKEN);
        localStorage.removeItem("userDetails");
        apiRequest.consoleProvider("Token verification failed");
        window.location.reload();
      }
    } catch (err) {
      localStorage.removeItem(AUTH_TOKEN);
      localStorage.removeItem("userDetails");
      apiRequest.consoleProvider("Token verification failed", err);
    }
  };

  useEffect(() => {
    if (token) {
      verifyTokenAuth();
    }
  }, [token]);

  if (!token) {
    return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}`} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
